export default "__VITE_ASSET__CZhUr4kj__"